import { Suggestion } from 'lib/hooks/ProviderSearch/types';
import {
  LocationSuggestion,
  ProviderSpecialty,
  ProviderSuggestion,
  SuggestionTypes
} from 'store/providerSearch/types';

export const providerSuggestionsResponseDTO = (suggestions: ProviderSuggestion[]): Suggestion[] => {
  if (suggestions) {
    return suggestions.map(s => ({
      category: SuggestionTypes.PROVIDER,
      value: s['@search.text'],
      providerId: s.corpProvId
    }));
  }
  return [];
};

export const specialtiesResponseDTO = (specialties: ProviderSpecialty[]): Suggestion[] => {
  if (specialties) {
    return specialties.map(s => ({
      category: SuggestionTypes.SPECIALTY,
      value: s.value
    }));
  }
  return [];
};

export const locationsResponseDTO = (locations: LocationSuggestion[]): Suggestion[] => {
  if (locations) {
    return locations.map(l => ({
      category: SuggestionTypes.LOCATIONS,
      value: l.location.name,
      locationId: l.location.locationId
    }));
  }
  return [];
};
